import { Typography } from "@material-ui/core";
import { useRef, useEffect } from "react";

import { useStyles } from "./CameraNav.styles";


interface CameraGroupNameProps {
    name: string,
    active: boolean
}


const CameraGroupName: React.FC<CameraGroupNameProps> = ({ name, active }) => {
    const muiClasses = useStyles();
    const sectionRef = useRef<HTMLElement>(null);

    useEffect(()=>{
        if (active && sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [active]);

    return (<Typography ref={sectionRef} variant="subtitle1" className={muiClasses.camListHeader}>{name}</Typography>);
};

export default CameraGroupName;
